import Vue from 'vue';

export let ToastService;

class Toast {
    init() {
        ToastService = new Vue();
    }

    showToast(type, message, duration = 7000) {
        const toast = {
            type,
            message, 
            duration
        }
        ToastService.$emit('showToast', toast);
    }

    info(message, duration) {
        this.showToast('info', message, duration);
    }

    success(message, duration) {
        this.showToast('success', message, duration);
    }

    error(message, duration) {
        this.showToast('warning', message, duration);
    }
}

export default new Toast();
